<template>
    <div>
        <div class='scroll-goods'>
            <div class="flex-between">
                <div class='row-title' v-if="title" :style="'color:'+styles.color+';font-size:'+styles.font_size+'px'+';font-weight:'+styles.font_weight">
                    {{title}}
                </div>
                <div style="margin-right: 15px">{{row.more_name}}</div>
            </div>
            <div class='scroll-box'>
                <div class='scroll-one' v-for="(item, index) in content">
                    <!-- <img :src='item.url.pic_url'> -->
                    <div class='scroll-goods-name show-two-row'>{{item.url.title}}</div>
                    <!-- <div class='scroll-goods-price'>¥99.99</div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .scroll-goods {
        background: #fff;
        overflow: hidden;
    }

    .row-title {
        padding: 10px 15px;
        font-size: 13px;
    }

    .scroll-box {
        padding-bottom: 12.5px;
        width: 100%;
        /* display: inline;
        white-space: nowrap;
        overflow-x: scroll;
        float: left;
        overflow-y: hidden; */
        display: flex;
        flex-wrap: wrap;
    }

    .scroll-one {
        /* width: 85px; */
        margin-left: 10px;
        display: inline-block;
        background: #FEEFD5;
        border-radius: 5px;
        margin-bottom: 10px;

    }

 

    .scroll-goods-name {
        padding: 0 5px;
        font-size: 12px;
        white-space: pre-wrap;
    }

    .show-two-row {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        height: 32px;
        line-height: 32px;
    }

    .scroll-goods-price {
        font-size: 12px;
        color: #FD2840;
        text-align: center;
    }

    .flex-start {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .flex-between {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .flex-end {
        display: flex;
        justify-content: space-end;
        align-items: center;
    }

    .flex-center {
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>

<script>
  export default {
    name: "DynamicList",
    components: {},
    props: {
      row: {
        type: Object,
        default: {},
      },
      content: {
        type: Array,
        default: [],
      },
      title: {
        type: String,
        default: '',
      },
      styles: {
        type: Object,
        default: ''
      }
    },

    data: function () {
      return {}
    },
    mounted(){
      console.log(this.content)
    },
    methods: {
      goGoodsDetail(url, id) {
        this.$router.push({
          path: '/' + url,
          query: {
            id: id
          }
        })
      }
    },

    filters: {}

  };
</script>

